import { S as SKYWALKER_TEMPLATE_ID_CAB, a as SKYWALKER_API_PATHS_CAB } from '../../../dist/cabs-f42a4e5a.esm.js';
import { R as RecentSearchDwebRenderer } from '../../../dist/renderer-d6798d3c.esm.js';
import { S as SkywalkerRenderEntry } from '../../../dist/renderer-entry-hoc-e84aaa62.esm.js';
import 'react';
import '@growth/use-analytics';
import '@growth/recent-search/Card/dweb';
import '@growth/carousal';
import '@growth/app-banners/Banners/DwebRecentSearchAppCard';
import '@growth/custom-hooks/useCardLoad';
import '../../../dist/style-04a88c28.esm.js';
import 'styled-components';
import '@growth/app-theme';
import '../../../dist/helper-59421a99.esm.js';
import '@growth/browser-storage';
import '@growth/custom-hooks/useApiCall';
import '@growth/validations';
import '@growth/dom-event-emitter';
import '@growth/error-card';
import '../../../fetcher/dist/growth-skywalker-fetcher.esm.js';
import '@growth/api-calls';
import '../../../dist/helpers-1e483015.esm.js';
import '@growth/gtm-push';
import '@growth/loader';

/** Templates mapped with indivisual card renderer */

var skywalkerCardComponentMaps = new Map([[SKYWALKER_TEMPLATE_ID_CAB.recentSearchDweb, RecentSearchDwebRenderer]]);

var fetcherConfig = {
  apiPath: SKYWALKER_API_PATHS_CAB.desktopHome,
  apiHeaders: {
    os: 'desktop'
  }
};
var SkywalkerWeb = SkywalkerRenderEntry({
  skywalkerCardComponentMaps: skywalkerCardComponentMaps,
  fetcherConfig: fetcherConfig
});

export { SkywalkerWeb };
